import { DropDownCategories } from 'src/types/generic';

export const invoiceScanManagerCategories: DropDownCategories[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Attached' },
  { value: 2, label: 'Show Unattached' },
];

export const invoiceDeleteAvailableCategories = [0, 2];
export const invoiceUnDeleteAvailableCategories = [0, 1, 2];
export const invoiceReassignAvailableCategories = [0, 2];
export const invoiceRunOcrScanAvailableCategories = [0, 2];

export const ocrScanCategories: DropDownCategories[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Scan in Progress' },
  { value: 2, label: 'Show Needs Review' },
  { value: 3, label: 'Show Failed' },
];
export const invoiceOcrDeleteAvailableCategories = [0, 2, 3];

export const useInvoiceScanManagerCategories = () => {
  const categories = [...invoiceScanManagerCategories];
  return categories;
};

export const useOcrScanCategories = () => {
  const categories = [...ocrScanCategories];
  return categories;
};
